import React, { useEffect, useState } from 'react';
import { Scroll, OutsideClicker } from 'components/UI';
import PropTypes from 'prop-types';
import { VelocityTransitionGroup } from 'velocity-react';
import * as _ from 'lodash';
import styles from './styles.scss';

const Select = props => {
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const [value, setValue] = useState(props.value);
  const { options = [] } = props;

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleChange = item => {
    const newValue = _.cloneDeep(value);
    const index = newValue.findIndex(el => el.id === item.id);
    if (index !== -1) {
      newValue.splice(index, 1);
    } else {
      newValue.unshift(item);
    }
    // newValue = _.sortBy(newValue || [], ['order']);
    props.onChange(newValue);
    setValue(newValue);
  };

  return (
    <div className={styles.container}>
      <OutsideClicker
        onClickOutSide={(status, e) => {
          if (isDropDownOpen) {
            setIsDropDownOpen(false);
          }
          e.stopPropagation();
        }}
      >
        <div className={styles.title} onClick={() => setIsDropDownOpen(true)}>
          Настроить список значений
        </div>
        <div className={styles.dropDown}>
          <VelocityTransitionGroup
            enter={{
              animation: {
                opacity: [1, 0],
              },
              duration: 200,
            }}
            leave={{
              animation: {
                opacity: [0, 1],
              },
              duration: 200,
            }}
          >
            {isDropDownOpen && (
              <Scroll universal autoHeightMax={218} style={{ width: 202 }}>
                <div className={styles.list}>
                  {options.length > 0 ? (
                    <React.Fragment>
                      {options.map(item => (
                        <div
                          key={item.id}
                          className={styles.item}
                          onClick={() => {
                            handleChange(item);
                            setIsDropDownOpen(false);
                          }}
                          style={{
                            height: props.height,
                          }}
                        >
                          {value.find(el => el.id === item.id) && <span className={styles.line} />}
                          <span className={styles.title}>{item.name}</span>
                        </div>
                      ))}
                    </React.Fragment>
                  ) : (
                    <span className={styles.empty}>Нет значений</span>
                  )}
                </div>
              </Scroll>
            )}
          </VelocityTransitionGroup>
        </div>
      </OutsideClicker>
    </div>
  );
};

Select.propTypes = {
  height: PropTypes.number,
  value: PropTypes.arrayOf(PropTypes.any),
  onChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
};

Select.defaultProps = {
  height: 30,
  value: [],
};

export default Select;
